import { combineReducers } from '@reduxjs/toolkit';
import { authenReducer } from './authenReducer';
import { quoteDetailReducer } from './quoteDetailReducer';
import { contentfulReducer } from './contentfulReducer';
import { toggleEditQuoteReducer } from './toggleEditQuoteReducer';
import { paramsQuoteDetailReducer } from './paramsQuoteDetailReducer';
import { itineraryReducer } from './itineraryReducer';
import { multipleQuotesReducer } from './multipleQuotesReducer';

const rootReducer = combineReducers({
    authen: authenReducer,
    quoteDetail: quoteDetailReducer,
    contentful: contentfulReducer,
    isEdit: toggleEditQuoteReducer,
    params: paramsQuoteDetailReducer,
    itinerary: itineraryReducer,
    multipleQuotes: multipleQuotesReducer,
});

export { rootReducer };
